<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('customer.charges.title') }}
        </h2>
        <date-select class="w-full lg:w-auto" />
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="charges.items"
          :toDetail="permissionIsEnabled('charge:get') && toDetail"
        ></Table>
        <empty-list
          v-if="!loadingList && showEmptyList()"
          entity="charges"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="charges.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import Table from '@/components/project/molecules/Table.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomerCharges',
  components: {
    EmdLoader,
    EmptyList,
    Pagination,
    Table,
    DateSelect: () => import('./DateSelect.vue')
  },
  data () {
    return {
      action: 'GET_CHARGES',
      fields: [
        {
          id: 'code',
          label: 'customer.charges.code',
          type: 'text'
        },
        {
          id: 'amount',
          label: 'customer.charges.amount',
          type: 'text'
        },
        {
          id: 'status',
          label: 'customer.charges.status',
          type: 'status'
        },
        {
          id: 'payment_method',
          label: 'customer.charges.payment-method',
          type: 'text'
        },
        {
          id: 'created_at',
          label: 'customer.charges.created-at',
          type: 'date',
          format: 'dateAndHour'
        }
      ],
      toDetail: {
        name: 'chargesDetail',
        params: {
          id: 'id'
        },
        query: ['created_at']
      }
    }
  },
  computed: {
    ...mapGetters(['merchant', 'account', 'charges', 'loadingListCharges']),
    loadingList () {
      return this.loadingListCharges
    },
    totalItems () {
      return this.charges.items.length
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.charges.pagination &&
        this.charges.pagination.total_items === 0
      )
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  }
}
</script>
